module.exports = __webpack_public_path__ + "img/gr.0690797f.svg";